import { render } from "./SelectTagseventComponent.vue?vue&type=template&id=17e1c324&scoped=true"
import script from "./SelectTagseventComponent.vue?vue&type=script&lang=js"
export * from "./SelectTagseventComponent.vue?vue&type=script&lang=js"

import "./SelectTagseventComponent.vue?vue&type=style&index=0&id=17e1c324&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17e1c324"]])

export default __exports__